import {noop} from 'lodash';
import {createContext} from 'react';

export const SearchFormOverlayContext = createContext({
  isSearchFormOverlayOpen: false,
  openSearchFormOverlay: noop,
  closeSearchFormOverlay: noop,
});
